export default __webpack_public_path__ + "static/media/RUGPULL ROADMAP 2-01.2a2f32dd.png";